import { PageHeader } from "@/components/PageHeader";
import { Mail, Megaphone, Sparkles, Clock } from "lucide-react";

const previews = [
  {
    icon: Mail, color: "#3B82F6", title: "Akıllı E-Posta Asistanı",
    desc: "Fatura ve banka maillerinizi otomatik ayıklar; gereksizleri gizler, sadece kritik vade ve ödeme maillerini özetleyerek gösterir.",
    items: ["Önemli mailleri öne çıkarma", "Reklam/spam gizleme", "Fatura & vade özeti", "Gmail/Outlook bağlantısı"],
  },
  {
    icon: Megaphone, color: "#F59E0B", title: "Sosyal Medya & Reklam Takibi",
    desc: "İstasyon kampanyalarınızı (LPG indirimi, market promosyonu, oto yıkama) tek panelden yönetin ve reklam performansını izleyin.",
    items: ["Kampanya oluşturma", "Instagram / Facebook paylaşımı", "Reklam performans raporu", "Otomatik gönderi planlama"],
  },
];

export default function Roadmap() {
  return (
    <div className="p-5 md:p-8 max-w-5xl">
      <PageHeader
        testid="roadmap-header"
        title="Yol Haritası — Yakında"
        subtitle="Talep ettiğiniz gelişmiş özellikler geliştirme sırasında. Aşağıdaki modüller önümüzdeki aşamalarda aktif olacak."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {previews.map((p) => (
          <div key={p.title} data-testid="roadmap-card" className="card-surface p-6 fade-up relative overflow-hidden">
            <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full blur-2xl" style={{ background: `${p.color}22` }} />
            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: `${p.color}1a` }}>
                  <p.icon className="w-6 h-6" style={{ color: p.color }} />
                </div>
                <span className="flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-full bg-[#111620] text-[#94A3B8]">
                  <Clock className="w-3 h-3" /> Yakında
                </span>
              </div>
              <h3 className="font-display text-lg font-bold mb-2">{p.title}</h3>
              <p className="text-sm text-[#94A3B8] leading-relaxed mb-4">{p.desc}</p>
              <div className="space-y-2">
                {p.items.map((it) => (
                  <div key={it} className="flex items-center gap-2 text-sm">
                    <Sparkles className="w-3.5 h-3.5" style={{ color: p.color }} />
                    <span className="text-[#94A3B8]">{it}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card-surface p-6 mt-5 fade-up text-center">
        <p className="text-sm text-[#94A3B8]">
          Bu modülleri aktifleştirmek istediğinizde bana söylemeniz yeterli —
          e-posta hesabınızı bağlayıp mail özetlemeyi, ardından sosyal medya reklam yönetimini ekleyebiliriz.
        </p>
      </div>
    </div>
  );
}
